'use es6';

import { EXPERIMENT_TREATMENTS_REQUESTED, EXPERIMENT_TREATMENTS_RECEIVED } from 'pricing-pages-unified-ui/constants/ActionTypes';
const initialState = {
  isLoading: false,
  treatments: {}
};
export default function ExperimentTreatments(state = initialState, {
  type,
  payload
}) {
  switch (type) {
    case EXPERIMENT_TREATMENTS_REQUESTED:
      return Object.assign({}, state, {
        isLoading: true
      });

    case EXPERIMENT_TREATMENTS_RECEIVED:
      return {
        isLoading: false,
        treatments: payload.treatments
      };

    default:
      return state;
  }
}